// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import firebase from 'firebase'
import 'firebase/firestore'
import VueFire from 'vuefire'
import VueSweetalert2 from 'vue-sweetalert2';
import VueLodash from 'vue-lodash'

Vue.config.productionTip = false

Vue.use(VueSweetalert2,VueLodash);

let app;
  // Initialize Firebase
let config = {
    apiKey: "AIzaSyDYktNAnSd0fSlhayTOXnrETY2v1dyFNYs",
    authDomain: "fs-kundenmanager.firebaseapp.com",
    databaseURL: "https://fs-kundenmanager.firebaseio.com",
    projectId: "fs-kundenmanager",
    storageBucket: "fs-kundenmanager.appspot.com",
    messagingSenderId: "137590816239"
  };
  
firebase.initializeApp(config);
firebase.auth().onAuthStateChanged(function(user){ 
  
  if(!app) {

    app = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
    
  }
})
/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js